import { render, staticRenderFns } from "./AppBarCentered.vue?vue&type=template&id=d5431fb8&scoped=true&"
import script from "./AppBarCentered.vue?vue&type=script&lang=js&"
export * from "./AppBarCentered.vue?vue&type=script&lang=js&"
import style0 from "./AppBarCentered.vue?vue&type=style&index=0&id=d5431fb8&scoped=true&lang=css&"
import style1 from "./AppBarCentered.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5431fb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAppBar,VAppBarNavIcon,VContainer,VTab,VTabs})
